import React,{useState,useEffect, Children} from 'react';

const LogoutButton=({customStyles})=>{
    const doLogout=()=>{
        localStorage.removeItem("alim-login-token");
        localStorage.removeItem("alim-user-email");
        localStorage.removeItem("alim-user-data");
        localStorage.removeItem("alimProfilePic");
        document.location.replace(`/login`);
    }

    return(
        <button onClick={doLogout} className={`blue-menu-button text-xs hover:underline ${customStyles}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
            </svg>
            Logout
        </button>
    );
}

export default LogoutButton;